export const ARCHON_ROOT = '/archon';
export const ARCHON_TASKS_COSTS_PATH = `${ARCHON_ROOT}/tasks-costs`;
/** The plain-language explanation of the Tasks & Costs projection, with the live figures. */
export const ARCHON_HOW_THE_ESTIMATE_WORKS_PATH = `${ARCHON_TASKS_COSTS_PATH}/how-it-works`;
export const ARCHON_ACCURACY_PATH = `${ARCHON_ROOT}/accuracy`;
/** Each vendor labeler's quizzes and Match tasks, against their vendor's peers. */
export const ARCHON_LABELERS_PATH = `${ARCHON_ROOT}/labelers`;
/** The Labelers page on its Gold tab: the author's next gold task and what they published. */
export const ARCHON_GOLD_PATH = `${ARCHON_LABELERS_PATH}?tab=gold`;
/** One gold task in the gold tool: its answers on the photo, edited into gold and published. */
export const archonGoldTaskPath = (taskId: number) => `${ARCHON_LABELERS_PATH}/gold/${taskId}`;
/** The Labelers page on its Quiz pool tab: every Match quiz with its numbers. */
export const ARCHON_QUIZ_POOL_PATH = `${ARCHON_LABELERS_PATH}?tab=quizzes`;
/** The Quiz pool's drafts: quizzes Gold wrote that nobody has made live. */
export const ARCHON_QUIZ_DRAFTS_PATH = `${ARCHON_QUIZ_POOL_PATH}&pool=draft`;
/** One quiz of the Quiz pool: its photo and answer, how labelers score on it, and its changes. */
export const archonQuizPath = (quizId: number) => `${ARCHON_LABELERS_PATH}/quizzes/${quizId}`;
/** One store as a dashboard: its Task flow, its cameras' repeat work and live templates. */
export const ARCHON_PER_STORE_PATH = `${ARCHON_ROOT}/per-store`;
export const ARCHON_MATCH_TRACE_PATH = `${ARCHON_ROOT}/match-trace`;
export const ARCHON_DATA_ROLLOUT_PATH = `${ARCHON_ROOT}/data/rollout-schedules`;
export const ARCHON_DATA_INVOICES_PATH = `${ARCHON_ROOT}/data/invoices`;
export const ARCHON_DATA_COST_MODEL_PATH = `${ARCHON_ROOT}/data/cost-model`;
export const ARCHON_DATA_INGRESS_SOURCES_PATH = `${ARCHON_ROOT}/data/ingress-sources`;
export const ARCHON_DATA_QA_SAMPLING_PATH = `${ARCHON_ROOT}/data/qa-sampling`;
/** What a chain's stores run on, read from the legacy Match settings, routes and camera rows. */
export const ARCHON_DATA_MATCH_CONFIG_PATH = `${ARCHON_ROOT}/data/match-config`;
/** Kit showcase: reachable by URL, deliberately out of the navigation. */
export const ARCHON_KIT_PATH = `${ARCHON_ROOT}/kit`;
